module.exports = __webpack_public_path__ + "static/media/weixin-bind-taotao.00df65e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/weixin-bind-taotao.png
// module id = 656
// module chunks = 1